"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));

var _FormikFormFieldModule = _interopRequireDefault(require("./FormikFormField.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FormikFormField = function FormikFormField(_ref) {
  var fieldName = _ref.fieldName,
      touched = _ref.touched,
      errors = _ref.errors,
      placeholder = _ref.placeholder,
      label = _ref.label,
      hideErrors = _ref.hideErrors,
      fieldProps = _ref.fieldProps,
      endAdornment = _ref.endAdornment,
      className = _ref.className,
      disabled = _ref.disabled;
  var showFieldErrors = touched[fieldName] && errors[fieldName] && !hideErrors;
  var fieldStyles = [_FormikFormFieldModule.default.InputField];

  if (disabled) {
    fieldStyles.push(_FormikFormFieldModule.default.disabled);
  }

  if (showFieldErrors) {
    fieldStyles.push(_FormikFormFieldModule.default.errored);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: [_FormikFormFieldModule.default.InputContainer, className].join(' ')
  }, /*#__PURE__*/_react.default.createElement(_core.InputLabel, {
    className: showFieldErrors ? [_FormikFormFieldModule.default.InputLabel, _FormikFormFieldModule.default.error].join(' ') : _FormikFormFieldModule.default.InputLabel
  }, label), /*#__PURE__*/_react.default.createElement("div", {
    className: _FormikFormFieldModule.default.FieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_formik.Field, _extends({
    name: fieldName,
    placeholder: placeholder,
    className: fieldStyles.join(' ')
  }, fieldProps, {
    disabled: disabled
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _FormikFormFieldModule.default.InputField__endAdornment
  }, endAdornment, showFieldErrors ? /*#__PURE__*/_react.default.createElement("div", {
    className: _FormikFormFieldModule.default.ErrorIconContainer
  }, /*#__PURE__*/_react.default.createElement(_Error.default, {
    className: _FormikFormFieldModule.default.ErrorIcon
  })) : null)), hideErrors ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: _FormikFormFieldModule.default.ErrorMessageContainer
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: fieldName
  })));
};

FormikFormField.propTypes = {
  fieldName: _propTypes.default.string.isRequired,
  touched: _propTypes.default.object.isRequired,
  errors: _propTypes.default.object.isRequired,
  placeholder: _propTypes.default.string,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.node, _propTypes.default.func]),
  hideErrors: _propTypes.default.bool,
  fieldProps: _propTypes.default.object,
  endAdornment: _propTypes.default.node,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool
};
var _default = FormikFormField;
exports.default = _default;

//# sourceMappingURL=FormikFormField.js.map